























































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Drag } from './toDrag';
import { plotServer, plotNoSqlService } from '@/api/installService';
import { PlotManagerMapComponent } from './PlotManagerMapComponent';
import GisEmapPanelEdit from './GisEmapPanelEdit.vue';
import MapResolver from '../../util/MapResolver';
import { Injectable, Container } from 'ca-middleware';
@Component({
  name: 'LayoutGisPlot',
  components: {
    GisEmapPanelEdit,
  },
  mixins: [MapResolver],
})
export default class LayoutGisPlot extends Vue {
  @Injectable() public container!: Container;
  public mapComponent: any;
  public timer: any;
  @Prop() public options: any;
  private leftTabArr = ['常用标绘', '应急标绘符号', '标绘工具箱', '管理标绘'];
  private leftTabIndex = 0;
  private whiteBoardFlag = true;
  private hotTabDatas = [];
  private hotIconIndex = -1;
  private commonTabDatas = [];
  private commonSecondIndex = -1;
  private commonFirstIndex = -1;
  private msg = '暂无数据';
  private filterText: any = '';
  private treeData: any = [];
  // 定义应急标绘tree展示的内容字段
  private defaultProps: any = {
    children: 'children',
    label: 'name',
  };
  private manageTabAllDatas = [
    {
      name: '未保存标绘',
      isShowInput: false,
      isShowPagination: false,
      list: [],
    },
    {
      name: '标绘方案',
      isShowInput: true,
      isShowPagination: true,
      inputKey: '',
      list: [],
    },
  ];
  private rules: any = {
    isEmpty: [{ validator: this.valNotempty, trigger: 'blur' }],
  };
  // 表单字段
  private ruleForm = { inputPlotName: '' };
  private eMapPanelEditObj = {};
  private showPanelEdit = false;
  private listObj = {
    inputKey: '',
    currentPage: 1,
  };

  private listTotal = 0;
  // 标绘图标
  private plotIcons: any;

  private iselenamechange: boolean = false;
  private changeDataObj = {
    id: '',
    schemaName: '',
  };

  // 是否渲染
  private rendered: boolean = false;
  // 打开面板
  public plotOpen() {
    return new Promise(async (resolve, reject) => {
      await this.plotInit();
      $('#plotCtrlMainWrap').fadeIn();
      resolve();
    });
  }
  // 隐藏面板
  public plotClose() {
    $('#plotCtrlMainWrap').fadeOut();
  }
  // 标绘工具箱初始化
  public plotInit() {
    return new Promise((resolve, reject) => {
      // 延迟渲染，第一次打开的时候渲染
      const self: any = this;
      if (this.rendered === false) {
        this.rendered = true;
        this.$nextTick(() => {
          // 懒加载

          self.resolveMap(this.options.mapId).then((event: any) => {
            this.initialize(event.map);
            resolve();
          });
        });
      } else {
        resolve();
      }
    });
  }
  // 监听应急标绘符号查询
  @Watch('filterText')
  private filterTextChange(val: any) {
    (this.$refs.tree as any).filter(val);
  }
  private filterNode(value: any, data: any) {
    if (!value) {
      return true;
    }
    return data.name.indexOf(value) !== -1;
  }
  private valNotempty(rule: any, value: any, callback: any) {
    if (this.ruleForm.inputPlotName === '') {
      callback(new Error('请输入方案名称！'));
    } else {
      callback();
    }
  }
  // 请求数据
  private getlistDatas(opt?: any) {
    this.manageTabAllDatas[1].list = [];
    this.mapComponent.refreshPlotSchemaList();
  }
  // 将请求到的list数据放入面板;
  private setListDatas(res: any) {
    if (res.length) {
      this.manageTabAllDatas[1].list = [];
      const temparr: any = this.manageTabAllDatas[1].list;
      res.map((item: any) => {
        const obj: any = item;
        temparr.push(
          Object.assign({}, obj, {
            toggle: '显示',
            showFlag: true,
            iselenamechange: false,
            newname: obj.val,
            name: obj.val, // item.tag.RELATION_ID,
            operation: '删除',
            id: obj.id,
          }),
        );
      });
    }
    this.listTotal = res.length;
  }
  // 请求常用标绘数据;
  private gethotDatas() {
    return new Promise((resolve, reject) => {
      // 1 service.hotTabDats 更换了请求方法，已替换成返回正确的请求
      plotServer
        .getConfig(this.options.configDir + 'frequentlyPlot.json')
        .then((res: any) => {
          const temp: any = res;
          const plotIconObj: any = this.plotIcons;
          this.hotTabDatas = temp[0].data;
          this.hotTabDatas.map((item: any) => {
            const obj: any = item;
            obj.icons = this.options.iconImageDir + '/' + obj.icons;
            obj.base64 = plotIconObj[obj.tit];
          });
          resolve();
        });
    });
  }
  // 请求应急标绘符号数据;
  private getPlotSymbol() {
    return new Promise((resolve, reject) => {
      // 1 service.hotTabDats 更换了请求方法，已替换成返回正确的请求
      plotServer
        .getConfig(this.options.configDir + 'emergencyPlotSymbol.json')
        .then((res: any) => {
          this.treeData = res.symbols;
          // const temp: any = res;
          // const plotIconObj: any = this.plotIcons;
          // this.hotTabDatas = temp[0].data;
          // this.hotTabDatas.map((item: any) => {
          //   const obj: any = item;
          //   obj.icons = this.options.iconImageDir + '/' + obj.icons;
          //   obj.base64 = plotIconObj[obj.tit];
          // });
          resolve();
        });
    });
  }
  // 点击应急标绘tree节点
  private handleNodeClick(data: any) {
    this.mapComponent.emergencyPlot(data);
  }
  // 请求标绘数据中文名称
  private getChinaTabNames() {
    return new Promise((resolve, reject) => {
      // 2 service.chinaTabNames 更换了请求方法，已替换成返回正确的请求
      plotServer
        .getConfig(this.options.configDir + 'nameRef.json')
        .then((res: any) => {
          // const temp = res.data ;
          const temp = res;
          this.getCommonTabDatas(temp.normalPlot);
          resolve();
        });
    });
  }
  // 请求标绘工具箱数据;
  private getCommonTabDatas(nameObj: any) {
    // 3 service.commonTabDatas 更换了请求方法，已替换成返回正确的请求
    return new Promise((resolve, reject) => {
      plotServer
        .getConfig(this.options.configDir + 'normalPlot.json')
        .then((res: any) => {
          // const temp: any = res.data ;
          const temp: any = res;
          const plotIconObj: any = this.plotIcons;
          temp.map((item: any) => {
            item.name = nameObj[item.boxName];
            item.data.map((ele: any) => {
              const ele1: any = ele;
              ele1.name = nameObj[ele.tit];
              ele1.icons = this.options.iconImageDir + '/' + ele.icons;
              ele1.base64 = plotIconObj[ele1.tit];
            });
          });
          this.commonTabDatas = temp;
          resolve();
        });
    });
  }
  // input监听
  private inputWatch(val: any) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.listObj.inputKey = val;
      this.listObj.currentPage = 1;
      // this.getlistDatas(this.listObj);
      this.mapComponent.planSearchBack(this.listObj.inputKey);
    }, 1000);
  }
  // input监听;
  private inputWatch1(val: any) {
    return false;
  }
  // 调用面板编辑;
  private getEMapPanelEdit(opt: any) {
    console.debug('编辑内容', opt);
    this.eMapPanelEditObj = opt;
    if (opt.key === 'point') {
      $('#eMapPanelEdit').fadeOut();
      return;
    }
    this.showPanelEdit = true;
  }
  // 关闭面板编辑
  private closeEMapPanelEdit() {
    this.eMapPanelEditObj = {};
    $('#eMapPanelEdit').fadeOut();
    this.showPanelEdit = false;
  }
  // tab选项切换
  private toTabItem(item: any, index: any) {
    this.leftTabIndex = index;
    this.hotIconIndex = -1;
    this.commonSecondIndex = -1;
    this.commonFirstIndex = -1;
    $('.commonTab').slideUp();
  }
  // 图标点击事件;
  private hotIconClick(item: any, idx: any, index: any) {
    if (this.leftTabIndex === 0) {
      this.hotIconIndex = idx;
    } else if (this.leftTabIndex === 2) {
      this.commonSecondIndex = idx;
      this.commonFirstIndex = index;
    }

    this.mapComponent.draw(item);
    // this.getEMapPanelEdit(item);
  }
  // 未保存标绘
  private noSaveplot(arr: any) {
    const tempArr: any = [];
    arr.map((item: any) => {
      const item1: any = item;
      tempArr.push({
        toggle: '隐藏',
        showFlag: false,
        iselenamechange: false,
        newname: item1.content,
        name: item1.content,
        operation: '删除',
        data: item1,
      });
    });
    this.manageTabAllDatas[0].list = tempArr;
  }
  // 点击保存标绘按钮
  private savePlotClick() {
    $('.savePlotName').fadeIn();
  }
  // 标绘工具箱标题点击事件
  private comTitleClick(item: any, index: any) {


    if (this.commonFirstIndex === index) {
        this.commonFirstIndex = -1;
    } else {
        this.commonFirstIndex = index;
    }

    $('.commonTabTitle')
      .eq(index)
      .next()
      .slideToggle();

    $('.commonTabTitle')
      .eq(index)
      .parent()
      .siblings()
      .find('.commonTab')
      .slideUp();
  }
  // 管理标绘标题点击事件
  private manageTabClick(item: any, index: any) {
    if (!item.list.length) {
      $('.commonTab').slideUp();
      $('.nodataLi')
        .eq(index)
        .slideToggle();
      $('.nodataLi')
        .eq(index)
        .parent()
        .siblings()
        .find('.nodataLi')
        .slideUp();
    } else {
      $('.nodataLi').slideUp();
      $('.manageTabTitle')
        .eq(index)
        .next()
        .slideToggle();
      $('.manageTabTitle')
        .eq(index)
        .parent()
        .siblings()
        .find('.commonTab')
        .slideUp();
    }
  }
  private showiselenamechange(ele: any, flag: string) {
    this.iselenamechange = !this.iselenamechange;
    this.changeDataObj = {
      id: ele.id,
      schemaName: ele.newname,
    };
    if (flag === 'quit') {
      this.changeDataObj = {
        id: '',
        schemaName: '',
      };
      return;
    }
  }
  private showiselenamechange1(flag: string) {
    if (flag === 'save') {
      this.mapComponent.updateSchema(this.changeDataObj);
      //  3获取列表 目前还不知道具体获取的啥 先放放 todo 1.1 应该是管理标绘的
      this.iselenamechange = !this.iselenamechange;
      this.getlistDatas(this.listObj);

      //                this.$confirm('确定修改标绘名称?', '提示', {
      //                    confirmButtonText: '确定',
      //                    cancelButtonText: '取消',
      //                    type: 'warning',
      //                }).then(( ) => {
      //                    // todo 此处应添加修改方法调用，并刷新列表
      //                    this.$message({
      //                        type: 'success',
      //                        message: '修改成功!',
      //                    });
      //                }).catch(( ) => {
      //                    this.$message({
      //                        type: 'info',
      //                        message: '已取消修改!',
      //                    });
      //                });
    }
  }
  // 表单验证
  private submitForm(formName: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.mapComponent.savePlotSchema(this.ruleForm.inputPlotName);
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  // 重置表单验证
  private resetForm(formName: any) {
    (this.$refs[formName] as any).resetFields();
  }
  // 点击保存标绘面板的确定按钮
  private saveNameClick() {
    this.submitForm('ruleForm');
    // 用户输入的名字需要传参
    // console.log(this.ruleForm.inputPlotName);
    // if (this.ruleForm.inputPlotName === '') {
    //   alert('方案名称不能为空');
    // } else {
    //   this.mapComponent.savePlotSchema(this.ruleForm.inputPlotName);
    // }
  }
  //  关闭事件
  private saveNameClose() {
    this.ruleForm.inputPlotName = '';
    this.resetForm('ruleForm');
    $('.savePlotName').fadeOut();
  }
  // 管理标绘列表显示、隐藏事件
  private listToggle(ele: any, idx: any, index: any) {
    if (ele.toggle === '显示') {
      ele.toggle = '隐藏';
      ele.showFlag = false;
    } else {
      ele.toggle = '显示';
      ele.showFlag = true;
    }
    if (index === 0) {
      // 未保存的显隐控制
      this.mapComponent.toggleUnsavedPlot(ele.data.id, !ele.showFlag);
    } else {
      // 方案的显隐控制
      if (!ele.showFlag) {
        this.mapComponent.planShowBack(ele.id);
      } else {
        this.mapComponent.planCleanBack(ele.id);
      }
    }

    // console.log(ele)
  }
  // 管理标绘列表删除事件
  private listDelete(ele: any, idx: any, index: any) {
    this.$confirm('是否删除标绘？?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        if (index === 0) {
          this.manageTabAllDatas[0].list.splice(idx, 1);
          this.mapComponent.removeUnsaved(ele.data.id);
        } else {
          this.manageTabAllDatas[1].list.splice(idx, 1);
          this.mapComponent.planDeleteBack(ele.id);
        }
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    // let isDel = confirm('是否删除标绘？');
    // if (isDel) {
    //   if (index === 0) {
    //     this.manageTabAllDatas[0].list.splice(idx, 1);
    //     this.mapComponent.removeUnsaved(ele.data.id);
    //     // console.log("未保存", ele)
    //   } else {
    //     this.manageTabAllDatas[1].list.splice(idx, 1);
    //     this.mapComponent.planDeleteBack(ele.id);
    //     // console.log("保存", ele)
    //   }
    // } else {
    //   return;
    // }
  }
  // 分页
  private handleCurrentChange(val: any) {
    this.listObj.currentPage = val;
    this.getlistDatas(this.listObj);
  }

  // -白板标绘-
  private whiteBoardClick() {
    this.mapComponent.whiteBoardClick(this.whiteBoardFlag);
    this.whiteBoardFlag = !this.whiteBoardFlag;
  }

  // -图形编辑器-
  private eMapPanelEdit(val: any) {
    console.debug('编辑后的标绘符号', val);
    this.mapComponent.plotElementUpdate(val);
  }

  private panelEditClose(val: any) {
    this.showPanelEdit = false;
  }

  private getSchemaData() {
    //            this.mapservices.list()

    // 替换写法
    plotNoSqlService.list();
  }

  private mapComponentEvents() {
    // 每次绘制完成时调用
    this.mapComponent.on('updateUnsavedView', (data: any) => {
      // console.log('每次绘制完成时调用', data);
      this.noSaveplot(data.data);
    });

    // 点击标绘图形打开编辑面板
    this.mapComponent.on('plotElementClick', (data: any) => {
      const temp: any = data;
      this.getEMapPanelEdit({ data: temp, key: temp.symbol.type });
    });
    // 关闭编辑面板
    this.mapComponent.on('clearEditPanel', () => {
      this.closeEMapPanelEdit();
    });
    // 查询标绘方案列表回调
    this.mapComponent.on('refreshSchemaList', (data: any) => {
      this.setListDatas(data.data);
    });
    // 标绘方案搜索回调
    this.mapComponent.on('planSearchBack', (data: any) => {
      this.manageTabAllDatas[1].list = [];
      this.setListDatas(data.data);
    });
    // 标绘方案搜索回调
    this.mapComponent.on('schemaSaveSuccess', () => {
      $('.savePlotName').fadeOut();
      this.manageTabAllDatas[0].list = [];
      this.getlistDatas(this.listObj);
    });
  }
  private created() {
    return false;
  }

  private mounted() {
    // 注释，修改为懒加载
    // 获取地图，地图加载完成后进入回调
    // const self: any = this;
    // self.resolveMap(this.options.mapId).then((event: any) => {
    //   this.initialize(event.map);
    // });
    if (this.messageBus) {
      this.messageBus.on('openPlot', () => {
        this.plotOpen();
      });
      this.messageBus.on('closePlot', () => {
        this.plotClose();
      });
    }
  }
  // 组件初始化
  private async initialize(map: any) {
    // 拖拽
    const toDragPlotCtrl: any = new Drag(
      '#plotCtrlMainWrap',
      '.emap_control_plotCtrl_top',
      this.options.drag,
    );
    toDragPlotCtrl.toDrag();

    const toDragSaveName: any = new Drag(
      '#savePlotName',
      '.saveName_top',
      this.options.drag,
    );
    toDragSaveName.toDrag();
    //
    const plotConf: any = this.options.service;
    // 初始化标绘组件
    this.mapComponent = new PlotManagerMapComponent({
      map,
      textLineLimit: this.options.textLineLimit,
    });
    this.mapComponent.addControl();
    // 初始化查询
    plotNoSqlService.options = plotConf;
    plotNoSqlService.dataSetId1 = 'planPlotData';
    plotNoSqlService.deserializer = new g2.core.Deserializer();
    this.mapComponent.setService(plotNoSqlService);
    // 事件注册
    this.mapComponentEvents();
    // 数据初始化
    this.plotIcons = await plotServer.getConfig(
      this.options.configDir + 'plotIcons.json',
    );
    // 设置图标
    this.mapComponent.setIcons(this.plotIcons);
    // 1常用标绘获取json初始化方法
    this.gethotDatas();
    // 2标绘工具箱获取json初始化方法
    this.getChinaTabNames();
    //  3获取列表 目前还不知道具体获取的啥 先放放 todo 1.1 应该是管理标绘的
    this.getlistDatas(this.listObj);
    // 获取应急标绘符号json
    this.getPlotSymbol();
  }
}
